module.exports = __webpack_public_path__ + "img/chi.3281ffbd.png";